module.exports = __webpack_public_path__ + "static/media/invite.45049e49.svg";